import { OrderInfo } from "../../order-info/order-info.model";
import { Authorizations } from "../authorization/authorization.model";
import { Records } from "../records/records.model";
import { Subjects } from "../subjects/subjects.model";
import { Subpoena } from "../subpoena/subpoena.model";

export interface Step {
    label: string;
    status: string;
    visible: boolean;
    value: number;
    icon: string;
}
export const steps: Step[] = [
    { label: 'Order Info', status: 'none', visible: true, value: 1, icon: 'icomoon-order-info' },
    { label: 'Subjects', status: 'none', visible: true, value: 2, icon: 'icomoon-subjects' },
    { label: 'Subpoena', status: 'none', visible: false, value: 3, icon: 'icomoon-subpoena' },
    { label: 'Authorization', status: 'none', visible: false, value: 4, icon: 'icomoon-subpoena' },
    { label: 'Records', status: 'none', visible: true, value: 5, icon: 'icomoon-records' }
];

export const states = [
    { name: 'California', value: 'CA' },
    { name: 'Texas', value: 'TX' },
    { name: 'Florida', value: 'FL' },
    { name: 'New Jersey', value: 'NJ' }
  ];

export enum PartyTypeCode {
    Person = 'Person',
    Organization = 'Organization',
    Anonymous = 'Anonymous'
}

export enum PartyRoleCode {
    Paralegal = 'paralegal',
    Other = 'other',
    Attorney = 'attorney',
    PlaintiffAttorney = 'plaintiff-attorney',
    DefendantAttorney = 'defendant-attorney',
    CoDefendantAttorney = 'co-defendant-attorney',
    Defendant = 'defendant',
    Plaintiff = 'plaintiff',
    BillTo = 'bill-to',
    DeliverTo = 'deliver-to',
    RecordSubject = 'record-subject',
    Court = 'court',
    RecordsCustodian = 'records-custodian',
    MedicalProvider = 'medical-provider',
    AmbulanceService = 'ambulance-service',
    Adjuster = 'adjuster'
}

// Request reference discriminated union - identifies requests by UUID (new) or number (existing)
export type RequestRef =
  | { kind: 'uuid';   value: string }  // new request
  | { kind: 'number'; value: string }; // existing request

/**
 * Type guard for UUID-based request references.
 * Narrows RequestRef to uuid variant.
 */
export function isUuidRef(ref: RequestRef): ref is { kind: 'uuid'; value: string } {
  return ref.kind === 'uuid';
}

/**
 * Type guard for number-based request references.
 * Narrows RequestRef to number variant.
 */
export function isNumberRef(ref: RequestRef): ref is { kind: 'number'; value: string } {
  return ref.kind === 'number';
}

export interface Order {
    orderInfo?: OrderInfo;
    subjects?: Subjects;
    subpoena?: Subpoena;
    authorization?: Authorizations;
    records?: Records;
}

export interface PartyEntry  {
  party: any;
  roles: any[];
};

export interface PartyRelationships {
  sourcePartyKey: string;
  targetPartyKey: string;
  relation: string;
}